import type { RefObject } from 'react';
import { useEffect, useState } from 'react';

import { PkTheme } from '@shared-types/common.types';
import { getElementPkTheme } from '@utilities/theme';

export const usePkTheme = (ref: RefObject<HTMLElement | null>) => {
  const [theme, setTheme] = useState<PkTheme>(PkTheme.LIGHT);

  useEffect(() => {
    if (!ref.current) return;
    const th = getElementPkTheme(ref.current);
    setTheme(th);
  }, [ref]);

  return theme;
};
